import request from './request'

export const createSpectrum = data => {
    return request({
        url: '/spectrum/create',
        method: 'POST',
        data
    })
}

export const getSpectrumList = pedigreeId => {
    return request({
        url: '/spectrum/getSpectrumList',
        method: 'POST',
        data: { pedigreeId: pedigreeId }
    })
}
export const removeSpectrumOutline = id => {
    return request({
        url: '/spectrum/removeSpectrumOutline',
        method: 'POST',
        data: { id: id }
    })
}
export const getSpectrumDefinitionList = () => {
    return request({
        url: '/spectrum/getSpectrumDefinitionList',
        method: 'POST'
    })
}
export const saveSpectrumDefinition = data => {
    return request({
        url: '/spectrum/saveSpectrumDefinition',
        method: 'POST',
        data
    })
}
export const deleteSpectrumDefinition = id => {
    return request({
        url: '/spectrum/removeSpectrumDefinition',
        method: 'POST',
        data: {
            id: id
        }
    })
}
export const getSpectrumContent = id => {
    return request({
        url: '/spectrum/getSpectrumContent',
        method: 'POST',
        data: {
            id: id
        }
    })
}
export const saveSpectrumContent = (data) => {
    return request({
        url: '/spectrum/saveSpectrumContent',
        method: 'POST',
        data
    })
}

export const getSpectrumDetail = id => {
    return request({
        url: '/spectrum/getSpectrumDetail',
        method: 'POST',
        data: { id }
    })
}
export const renameSpectrumContent = (id, title) => {
    return request({
        url: '/spectrum/renameSpectrumContent',
        method: 'POST',
        data: {
            id,
            title
        }
    })
}
